module.exports = __webpack_public_path__ + "static/media/brandeis_marshall.b1b79cac.jpg";